// extracted by mini-css-extract-plugin
export default {"item":"UserInfoSection_item__IzifB","verified":"UserInfoSection_verified__zNTV8","role":"UserInfoSection_role__jMrf4","status":"UserInfoSection_status__fO2BF"};